import Page from '@cinch/oxd-pages/recommended-cars/src'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import SEO, { Breadcrumb } from '../components/seo'

const RecommendedCars: React.FC<Cinch.SitePage> = ({ location }) => {
  const data: any = useStaticQuery(graphql`
    query RecommendedCarQuery {
      allTranslations {
        edges {
          node {
            recommendations {
              title
              subTitle
              listHeading
              updateAnswer
              saleCTA
              starMessage
              loadingTitle
              noResults {
                title
                subTitle
                updateAnswer
                saleCTA
              }
            }
          }
        }
      }
    }
  `)

  const i18n = data.allTranslations.edges[0].node.recommendations

  const breadcrumbs: Breadcrumb[] = []

  if (location) {
    const pageUrl = `${getEnv(Env.SiteUrl)}${location.pathname}`
    breadcrumbs.push({
      item: pageUrl,
      name: i18n.title,
    })
  }

  return (
    <>
      <SEO title={i18n.title} />
      <Page i18n={i18n} />
    </>
  )
}

export default RecommendedCars
